export const ICON_GROUPS = {
  app: ["block", "make-reverse", "print-ok"],
  collection: ["collection"],
  "help-fab": ["close", "interrogation"],
  financial: ["boleto", "dashboard", "money"],
  mandae: ["logo"],
  menu: ["charts", "chat", "collection", "package", "settings"],
  packages: ["collections", "incident", "list", "return", "reverse", "report"]
};
